$(document).ready(function(){
    (function() {
        var Q1 = '',
        Q2 = '',
        Q3 = '',
        Q4 = '',
        Q5 = '',
        Q6 = '',
        Q7 = '',
        questionsOrder = '';

        $('.label-quizz').on('click', function(){
            setTimeout(function(){
                $('#suivant-question').click();
            }, 200)
            $('#suivant-question').hide();
        })

        function ChangeQuestion(currentQuestion, question, response) {
            if( response != undefined){
                $(currentQuestion).removeClass('active').addClass('previous-question').hide();
                $(question).fadeIn(300).addClass('active');
                $('#error').hide();
            }
            else{
                $('#error').show();
            }
        }
        $('#suivant-question').on('click', function(e){
            e.preventDefault();
            var response = $('.question.active input:checked').val();
            var questionNumber = parseInt($('.question.active input').attr('question-number'));
            questionsOrder = questionsOrder + questionNumber;
            switch (questionNumber) {
                case 1:
                Q1 = response;
                break;
                case 2:
                Q2 = response;
                break;
                case 3:
                Q3 = response;
                break;
                case 4:
                Q4 = response;
                break;
                case 5:
                Q5 = response;
                break;
                case 6:
                Q6 = response;
                break;
                case 7:
                Q7 = response;
                break;
            }

            var currentQuestion = '#question-' + questionNumber;
            var nextQuestion = '#question-' + (questionNumber + 1);

            if ( questionNumber == 1 ) {
                setTimeout(function(){
                    $('#precedent-question').show();
                }, 350);
                if (response == 'a') {
                    ChangeQuestion(currentQuestion, nextQuestion, response);
                } else {
                    ChangeQuestion(currentQuestion, '#question-3', response);
                }
            } else if ( questionNumber == 3 ) {
                if (response == 'e') {
                    ChangeQuestion(currentQuestion, nextQuestion, response);
                } else {
                    ChangeQuestion(currentQuestion, '#question-5', response);
                }
            }
            else if ( questionNumber == 5 ) {
                if (response == 'i') {
                    ChangeQuestion(currentQuestion, nextQuestion, response);
                } else {
                    ChangeQuestion(currentQuestion, '#question-7', response);
                }
            } else if (questionNumber != 7) {
                ChangeQuestion(currentQuestion, nextQuestion, response);
            } else {
                if(response != undefined){
                    $('#resultats').show();
                    var result = Q1 + Q2 + Q3 + Q4 + Q5 + Q6 + Q7;
                    var skin_type = '';
                    $('#error').hide();
                    if (result.match(/^ad/)) {
                        skin_type = 'Peau grasse';
                        $("#resultats a").attr('href', '/pages/diagnostic-beaute-resultat'+"?type=grasse");
                    } else if (result.match(/(^acegi)|(^acehi)|(^acfi)/)) {
                        skin_type = 'Peau Mixte Déshydratée';
                        $("#resultats a").attr('href', '/pages/diagnostic-beaute-resultat'+"?type=mixte-deshydratee");
                    } else if (result.match(/(^acegj)|(^acehj)|(^acfj)/)) {
                        skin_type = 'Peau Mixte';
                        $("#resultats a").attr('href', '/pages/diagnostic-beaute-resultats'+"?type=mixte");
                    } else if (result.match(/(^begik)/)) {
                        skin_type = 'Peau sèche sensible';
                        $("#resultats a").attr('href', '/pages/diagnostic-beaute-resultats'+"?type=seche-sensible");
                    } else if (result.match(/(^bfik)/)) {
                        skin_type = 'Peau sèche';
                        $("#resultats a").attr('href', '/pages/diagnostic-beaute-resultats'+"?type=seche");
                    } else {
                        skin_type = 'Peau normale';
                        $("#resultats a").attr('href', '/pages/diagnostic-beaute-resultat'+"?type=normale");
                    }
                    $('#result-quizz').text("Votre diagnostic : Vous avez une peau de type " + skin_type);
                    $('#result-quizz').show();
                    $('#resultats').show();
                }
                else{
                    $('#error').show();
                }
            }
        });

        $('#precedent-question').on('click', function(e){
            $('#result-quizz').hide();
            $('#resultats').hide();
            e.preventDefault();
            var questionNumber = parseInt($('.question.active input').attr('question-number'));
            var currentQuestion = '#question-' + questionNumber;
            var previousQuestion = '#question-' + (questionsOrder.slice(-1));
            questionsOrder = questionsOrder.substring(0, questionsOrder.length - 1);
            if(previousQuestion == '#question-1'){
                $('#precedent-question').hide();
            }
            $('#suivant-question').show();

            $(currentQuestion).removeClass('active').hide();
            $(previousQuestion).fadeIn(300).addClass('active');

        });
    }());
});


$('.blockRose').click(function() {
    $('html, body').animate({
        scrollTop: $("#quizz").offset().top - 600
    }, 600);
  });
